import * as React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormLabel from '@mui/material/FormLabel';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/styles": { ThemeProvider, createTheme }, "@mui/material/Box": Box, "@mui/material/Button": Button, "@mui/material/Radio": Radio, "@mui/material/RadioGroup": RadioGroup, "@mui/material/FormLabel": FormLabel, "@mui/material/FormControlLabel": FormControlLabel, "@mui/material/FormControl": FormControl } } });
export default ClientProvider;
